<template>
    <div class="section">
        
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <a :href="blogUrl" class="has-text-dark"><b-icon icon="undo" size="is-small"></b-icon> Volver al listado</a>
                <p class="title">{{entry.title}}</p>
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <div>
                                <p>{{ new Date(entry.timestamp).toLocaleDateString() }}</p>
                            </div>
                        </div>
                        <div class="level-item">
                            <div>
                                <p>| {{entry.authorName}}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="entry.sectionObj" class="level-right">
                        <div class="level-item">
                            <div>
                                <span class="tag is-custom is-rounded">{{entry.sectionObj.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <img :src="entry.thumbnail" alt="">
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <ProductsTaged
                v-if="products != undefined && products.length"
                :loadingTags="loadingProds"
                :tags="products"
                />
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <div class="ql-editor" v-html="entry.content"></div>
            </div>
        </div>
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <ProductsTaged
                v-if="products != undefined && products.length"
                :loadingTags="loadingProds"
                :tags="products"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../services/http'
import ProductsTaged from './components/ProductsTaged.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
export default {
    components:{
        ProductsTaged
    },
    props:{
        blogDetail:{
            type:String,
            default:""
        },
        prodsTags:{
            type:String,
            default:""
        },
        blogUrl:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            loading:false,
            loadingProds:false,
            entry:{},
            products:[]
        }
    },
    methods:{
        async fetchEntry(){
            this.loading = true
            this.entry = await getHandler(this.blogDetail, {error:false, success:false})
            this.loading = false
        },
        async fetchTags(){
            this.loadingProds = true
            this.products = await getHandler(this.prodsTags, {error:false, success:false})
            this.loadingProds = false
        }
    },
    created(){
        this.fetchEntry()
        this.fetchTags()
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    color:var(--text-color);
    background:var(--primary);
}


.thumbnail{
    border-radius: 5%;
}

.masthead {
  max-height:500px;
  margin-bottom: 50px;
  background: no-repeat center center;
  background-color: #868e96;
  background-attachment: scroll;
  position: relative;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

</style>